import styled from '@emotion/styled';
import { Breakpoints } from '../../../styles/variables/breakpoints';
import { TextStyle } from '../../../styles/variables/mixins';
import { Colors } from 'styles/variables/colors';

const { lg, sm, xs } = Breakpoints;
const { white, lightGray, blue } = Colors;

type Props = {
    selected: boolean;
};

export const GradientText = styled.span`
    /* gradient */
    background-image: linear-gradient(to bottom, #7400f8, white);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    color: transparent;
    /* fallback background color */
    background-color: #8b25ff;
`;

export const AIRecommended = styled.p`
    margin-top: 2rem;
    line-height: 1.2;
    text-align: center;
    ${TextStyle({ fontSize: '30px', fontWeight: '700' })};
    @media (max-width: ${lg}) {
        font-size: 27px;
    }
    @media (max-width: ${sm}) {
        font-size: 24px;
    }

    @media (max-width: ${xs}) {
        font-size: 20px;
    }
`;

export const SelectCountryContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 1.3rem;
    margin-top: 1rem;
    @media (max-width: ${lg}) {
        margin-top: 0;
    }

    @media (max-width: ${sm}) {
        gap: 1rem;
    }
    @media (max-width: 721px) {
        margin-bottom: 1rem;
    }

    @media (max-width: ${xs}) {
        gap: 0.8rem;
    }
`;

export const SelectCountry = styled.h2`
    text-align: center;
    ${TextStyle({ fontSize: '25px', fontWeight: '700' })};
    @media (max-width: ${lg}) {
        font-size: 20px;
    }
    @media (max-width: ${sm}) {
        font-size: 17px;
    }
`;

export const ButtonContainer = styled.span<Props>`
    padding: 0.25rem;
    background: ${white};
    border: ${({ selected }) => (selected ? `2px solid ${blue}` : `1px solid ${lightGray}`)};
    border-radius: 4px;
`;

export const Calendar = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const Button = styled.button<Props>`
    display: flex;
    justify-content: center;
    border-radius: 4px;
    box-shadow: ${({ selected }) => (selected ? `0px 1px 14px ${blue}` : '')};
    transform: ${({ selected }) => (selected ? 'scale(1.2)' : '')};
    &:hover {
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    }
    &:focus {
        box-shadow: 0px 4px 8px ${blue};
    }
`;

export const SelectedContainer = styled.div<Props>`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: ${({ selected }) => (selected ? '1.4rem' : '')};

    @media screen and (max-width: 500px) {
        margin-top: ${({ selected }) => (selected ? '0.8rem' : '')};
    }
`;

export const Word = styled.div`
    ${TextStyle({ fontSize: '18px', fontWeight: '600' })};
    margin-top: 1.3rem;
    line-height: 0;

    @media screen and (max-width: ${sm}) {
        font-size: 16px;
    }
`;
